import {trpc} from "@/app/trpc";
import {useQuery} from "@tanstack/react-query";
import {Loader, ExpandableBlock, YStack} from "@chayka/ui";

export const Rules = () => {
  const {data, isFetching} = useQuery(trpc.rules.list.queryOptions({}));
  return (
    <>
      {isFetching && (
        <div className="flex p-6 justify-center">
          <Loader />
        </div>
      )}
      <YStack className="gap-2">
        {!isFetching &&
          data?.map((rule) => (
            <ExpandableBlock
              key={rule.title}
              label={<div className="text-lg font-medium w-full">{rule.title}</div>}
            >
              <p className="font-light whitespace-pre-wrap">{rule.text}</p>
            </ExpandableBlock>
          ))}
      </YStack>
    </>
  );
};
